import React, { useState } from "react";
import LogoLight from "../../asset/logo_light.png";
import "./LoginAndSignup.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
const config = require("../../config.js");
const translations = {
  english: {
    username: "User Name",
    companyName: "Company Name",
    password: "Password",
    adressdescription: "Company Adress",
    street: "Street",
    city: "City",
    zipcode: "Zipcode",
    currency: "Currency",
    CurrencyHelp: "Currency",
    email: "Email Address",
    alreadyRegistered: "Already Registered? Go to login page.",
    signup: "Signup",
    failed: "Registration failed",
  },
  german: {
    username: "Benutzername",
    companyName: "Firmenname",
    password: "Passwort",
    adressdescription: "Unternehmensanschrift",
    street: "Straße",
    city: "Ort",
    zipcode: "Postleitzahl",
    currency: "Währung",
    CurrencyHelp:
      "Bitte geben Sie an in welcher Währung Ihre Angaben sind. Die Währung kann später nicht mehr gewechselt werden.",
    email: "E-Mail Adresse",
    alreadyRegistered: "Bereits registriert? Gehen Sie zur Login-Seite.",
    signup: "Registrieren",
    failed: "Registrierung ist fehlgeschlagen",
  },
  italian: {
    username: "Nome Utente",
    companyName: "Nome Azienda",
    password: "Password",
    adressdescription: "Indirizzo dell'azienda",
    street: "Via",
    city: "Città",
    zipcode: "Codice postale",
    currency: "Valuta",
    email: "Indirizzo Email",
    alreadyRegistered: "Già registrato? Vai alla pagina di accesso.",
    signup: "Registrati",
    failed: "Registrazione fallita",
  },
  czech: {
    username: "Uživatelské Jméno",
    companyName: "Název Společnosti",
    password: "Heslo",
    adressdescription: "Unternehmensanschrift",
    street: "",
    city: "",
    zipcode: "",
    currency: "",
    email: "Emailová Adresa",
    alreadyRegistered: "Již registrováni? Přejděte na přihlašovací stránku.",
    signup: "Registrovat se",
    failed: "Registrace se nezdařila",
  },
};

function SignupPage() {
  const [name, setName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [street, setStreet] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [city, setCity] = useState("");
  const [currency, setCurrency] = useState("€");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem("language") || "english"
  );
  const lang = translations[currentLanguage];

  const clearInput1 = () => setName("");
  const clearInput2 = () => setCompanyName("");
  const clearInput3 = () => setEmail("");
  const clearInput4 = () => setPassword("");
  const clearInput5 = () => setStreet("");
  const clearInput6 = () => setZipcode("");
  const clearInput7 = () => setCity("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      const response = await axios.post(
        config.env.API_BASE_URL + "/api/auth/register",
        {
          name,
          companyName,
          street,
          zipcode,
          city,
          email,
          currency,
          password,
        }
      );
      setSuccess(response.data);
      setName("");
      setCompanyName("");
      setEmail("");
      setPassword("");
      setStreet("");
      setZipcode("");
      setCity("");
      setCurrency("€");
      alert("Account created. Once the account is confirmed by an admin you will be able to log in to the platform.");
      navigate("/login"); // Redirect to login page after successful registration
    } catch (error) {
      setError(error.response ? error.response.data.message : lang.failed);
    }
  };

  const GotoLoginPage = () => {
    navigate("/login");
  };

  return (
    <div className="loginandsignup-main">
      <div style={{cursor:"pointer", left: "30px", position: "absolute", top: "50px"}} onClick={() => {
              window.location.href = '/';
            }}>
              <FontAwesomeIcon icon={faArrowLeftLong} />
              <span style={{ marginLeft: "10px" }}>Back</span>
            </div>
      <div className="d-flex justify-content-center align-items-center flex-column gap-4">
        <img src={LogoLight} alt="logo" width={300} />
        <section className="loginandsignup">
          <form onSubmit={handleSubmit}>
            {error && <p className="error-message">{error}</p>}
            {success && <p className="success-message">{success}</p>}
            <div className={`input-wrap ${name ? "has-value" : ""}`}>
              <input
                type="text"
                className="login-input1"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <label>{lang.username}</label>
              {name && (
                <button
                  type="button"
                  className="clear-button"
                  onClick={clearInput1}
                >
                  <FontAwesomeIcon
                    className="input-close-icon"
                    icon={faCircleXmark}
                  />
                </button>
              )}
            </div>
            <div className={`input-wrap ${companyName ? "has-value" : ""}`}>
              <input
                type="text"
                className="login-input2"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />
              <label>{lang.companyName}</label>
              {companyName && (
                <button
                  type="button"
                  className="clear-button"
                  onClick={clearInput2}
                >
                  <FontAwesomeIcon
                    className="input-close-icon"
                    icon={faCircleXmark}
                  />
                </button>
              )}
            </div>
            <div className={`input-wrap ${email ? "has-value" : ""}`}>
              <input
                type="email"
                className="login-input3"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label>{lang.email}</label>
              {email && (
                <button
                  type="button"
                  className="clear-button"
                  onClick={clearInput3}
                >
                  <FontAwesomeIcon
                    className="input-close-icon"
                    icon={faCircleXmark}
                  />
                </button>
              )}
            </div>
            <div className={`input-wrap ${password ? "has-value" : ""}`}>
              <input
                type="password"
                className="login-input4"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <label>{lang.password}</label>
              {password && (
                <button
                  type="button"
                  className="clear-button"
                  onClick={clearInput4}
                >
                  <FontAwesomeIcon
                    className="input-close-icon"
                    icon={faCircleXmark}
                  />
                </button>
              )}
            </div>
            <div className={"CurrencyHelp"}>
              <small>{lang.CurrencyHelp}</small>
            </div>
            <div className={`input-wrap ${currency ? "has-value" : ""}`}>
              <label>{lang.currency}</label>
              <select
                className="login-inputSelect"
                onChange={(e) => setCurrency(e.target.value)}
              >
                <option value="€">€</option>
                <option value="Kč">Kč</option>
              </select>
            </div>

            <label>{lang.adressdescription}</label>
            <div className={`input-wrap ${street ? "has-value" : ""}`}>
              <input
                type="text"
                className="login-input4"
                value={street}
                onChange={(e) => setStreet(e.target.value)}
              />
              <label>{lang.street}</label>
              {street && (
                <button
                  type="button"
                  className="clear-button"
                  onClick={clearInput5}
                >
                  <FontAwesomeIcon
                    className="input-close-icon"
                    icon={faCircleXmark}
                  />
                </button>
              )}
            </div>
            <div className={`input-wrap ${zipcode ? "has-value" : ""}`}>
              <input
                type="text"
                className="login-input5"
                value={zipcode}
                onChange={(e) => setZipcode(e.target.value)}
              />
              <label>{lang.zipcode}</label>
              {zipcode && (
                <button
                  type="button"
                  className="clear-button"
                  onClick={clearInput6}
                >
                  <FontAwesomeIcon
                    className="input-close-icon"
                    icon={faCircleXmark}
                  />
                </button>
              )}
            </div>
            <div className={`input-wrap ${city ? "has-value" : ""}`}>
              <input
                type="text"
                className="login-input6"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
              <label>{lang.city}</label>
              {city && (
                <button
                  type="button"
                  className="clear-button"
                  onClick={clearInput7}
                >
                  <FontAwesomeIcon
                    className="input-close-icon"
                    icon={faCircleXmark}
                  />
                </button>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button type="submit" className="btn-signup">
                {lang.signup}
              </button>
            </div>
            <p
              className="fw-light"
              style={{ cursor: "pointer" }}
              onClick={GotoLoginPage}
            >
              {lang.alreadyRegistered}
            </p>
          </form>
        </section>
      </div>
    </div>
  );
}

export default SignupPage;
